export default __webpack_public_path__ + "static/5-498689fd19b803ced7c8fcbaea39ce64.webp";